export default "__VITE_ASSET__53d0f91c__"